export default "__VITE_ASSET__a2fF5cvE__"